import React from "react";

const Settings: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-secondary-900">Settings</h1>
      {/* Add your settings implementation here */}
    </div>
  );
};

export default Settings;
